import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter, map, Observable, of } from 'rxjs';
import { BasicDataResult } from 'src/app/core/services/data-orchestrator';
import { EVENTS_FACADE, REGISTER_FACADE } from 'src/app/core/services/facades';
import { AccountActivated } from 'src/app/shared/models/events/events';
import { RegisterAdapter, RegisterAdapterRegisterResult } from 'src/app/shared/models/register-adapter.model';

@Injectable()
export class CustomerIdRegisterAdapterService implements RegisterAdapter {
  private readonly registerFacade = inject(REGISTER_FACADE);
  private readonly eventsFacade = inject(EVENTS_FACADE);

  public register(
    password: string,
    route: ActivatedRouteSnapshot,
  ): Observable<BasicDataResult<RegisterAdapterRegisterResult>> {
    const eventData: AccountActivated = {
      customerId: route.queryParamMap.get('customerId'),
      emailAddress: route.queryParamMap.get('customerEmail'),
      logId: route.queryParamMap.get('logId'),
      newPassword: password,
      tempPassword: '',
    };

    return this.eventsFacade
      .sendEventWithResponse({
        eventType: 'AccountActivated',
        jsonData: eventData,
      })
      .pipe(
        map((result) => {
          if (result && !result.loading && !result.error) {
            return {
              ...result,
              data: {
                email: route.queryParamMap.get('customerEmail'),
                password,
              },
            };
          }

          return {
            ...result,
            data: null,
          };
        }),
      );
  }

  public canRegister(route: ActivatedRouteSnapshot): Observable<boolean> {
    const customerEmail = route.queryParamMap.get('customerEmail');

    if (!customerEmail) {
      return of(false);
    }

    const { data$ } = this.registerFacade.isAccountActive({
      customerEmail,
      readFromCacheFirst: false,
    });

    return data$.pipe(
      filter((result) => !result.loading),
      map((result) => {
        if (result.error) {
          return false;
        }

        return !result.data;
      }),
    );
  }
}
